/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions,
    DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderSave
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderSave {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    product_type_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    location_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    fabric_color_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    fabric_type_ids?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    emb_outline_format_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    delivery_option_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    thread_supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    supplier_product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    thread_manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    design_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    width?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    height?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    measurement_unit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    instructions?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    is_same_day_order?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    is_sew_out?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    client_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    po_number?: string | null;
    /**
     * 
     * @type {DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    design_adaptions?: DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    coupon_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    coupon_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderSave
     */
    is_submitted?: boolean;
}

export function DigitizingserviceMelcoDigitizingModelsOrderSaveFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderSave {
    return DigitizingserviceMelcoDigitizingModelsOrderSaveFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderSaveFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderSave {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_type_id': !exists(json, 'product_type_id') ? undefined : json['product_type_id'],
        'location_id': !exists(json, 'location_id') ? undefined : json['location_id'],
        'fabric_color_id': !exists(json, 'fabric_color_id') ? undefined : json['fabric_color_id'],
        'fabric_type_ids': !exists(json, 'fabric_type_ids') ? undefined : json['fabric_type_ids'],
        'emb_outline_format_id': !exists(json, 'emb_outline_format_id') ? undefined : json['emb_outline_format_id'],
        'delivery_option_id': !exists(json, 'delivery_option_id') ? undefined : json['delivery_option_id'],
        'thread_supplier_id': !exists(json, 'thread_supplier_id') ? undefined : json['thread_supplier_id'],
        'supplier_product_id': !exists(json, 'supplier_product_id') ? undefined : json['supplier_product_id'],
        'thread_manufacturer': !exists(json, 'thread_manufacturer') ? undefined : json['thread_manufacturer'],
        'design_name': !exists(json, 'design_name') ? undefined : json['design_name'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'measurement_unit': !exists(json, 'measurement_unit') ? undefined : json['measurement_unit'],
        'instructions': !exists(json, 'instructions') ? undefined : json['instructions'],
        'is_same_day_order': !exists(json, 'is_same_day_order') ? undefined : json['is_same_day_order'],
        'is_sew_out': !exists(json, 'is_sew_out') ? undefined : json['is_sew_out'],
        'client_name': !exists(json, 'client_name') ? undefined : json['client_name'],
        'po_number': !exists(json, 'po_number') ? undefined : json['po_number'],
        'design_adaptions': !exists(json, 'design_adaptions') ? undefined : DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsFromJSON(json['design_adaptions']),
        'coupon_code': !exists(json, 'coupon_code') ? undefined : json['coupon_code'],
        'coupon_amount': !exists(json, 'coupon_amount') ? undefined : json['coupon_amount'],
        'is_submitted': !exists(json, 'is_submitted') ? undefined : json['is_submitted'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderSaveToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderSave | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_type_id': value.product_type_id,
        'location_id': value.location_id,
        'fabric_color_id': value.fabric_color_id,
        'fabric_type_ids': value.fabric_type_ids,
        'emb_outline_format_id': value.emb_outline_format_id,
        'delivery_option_id': value.delivery_option_id,
        'thread_supplier_id': value.thread_supplier_id,
        'supplier_product_id': value.supplier_product_id,
        'thread_manufacturer': value.thread_manufacturer,
        'design_name': value.design_name,
        'width': value.width,
        'height': value.height,
        'measurement_unit': value.measurement_unit,
        'instructions': value.instructions,
        'is_same_day_order': value.is_same_day_order,
        'is_sew_out': value.is_sew_out,
        'client_name': value.client_name,
        'po_number': value.po_number,
        'design_adaptions': DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsToJSON(value.design_adaptions),
        'coupon_code': value.coupon_code,
        'coupon_amount': value.coupon_amount,
        'is_submitted': value.is_submitted,
    };
}


